import { render, staticRenderFns } from "./roi.vue?vue&type=template&id=644fa4ea&"
import script from "./roi.vue?vue&type=script&lang=js&"
export * from "./roi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports